import { liveFeed } from "@/mocks/guaData";

// 更新条压顶：滚动的最新瓜单提醒
export default function UpdateTicker() {
  const items = [...liveFeed, ...liveFeed];
  return (
    <section aria-label="实时更新条" className="border-b border-background-200/70 bg-background-100/80">
      <div className="mx-auto flex max-w-7xl items-center px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 py-2.5 pr-3 text-xs font-bold uppercase tracking-wide text-foreground-950">
          <span className="h-2 w-2 animate-blinkDot rounded-full bg-accent-500" />
          更新中
        </span>
        <div className="relative min-w-0 flex-1 overflow-hidden" aria-hidden="true">
          <div className="ticker-track flex items-center gap-0">
            {items.map((item, idx) => (
              <span key={idx} className="flex items-center whitespace-nowrap text-xs text-foreground-600">
                <span className="mx-3 text-background-300">·</span>
                <span className="font-medium text-primary-600">{item.tag}</span>
                <span className="mx-1.5 truncate">{item.title}</span>
              </span>
            ))}
          </div>
        </div>
        <span className="ml-3 hidden shrink-0 whitespace-nowrap text-xs text-foreground-400 md:block">
          最新瓜单实时滚动
        </span>
      </div>
    </section>
  );
}